export const SORT_OPTIONS = [
  { value: 'price|ASC', text: 'Prezzo crescente' },
  { value: 'price|DESC', text: 'Prezzo decrescente' },
  { value: '', text: 'Ordina per' },
]

/**
 * Sort products array by the given sort key.
 * Returns a new sorted array (does not mutate).
 */
export function apply_sort(products, sort_key) {
  const sorted = [...products]

  switch (sort_key) {
    case 'price|DESC':
      sorted.sort((a, b) => Number(b.price) - Number(a.price))
      break

    case 'price|ASC':
      sorted.sort((a, b) => Number(a.price) - Number(b.price))
      break

    default:
      break
  }

  return sorted
}

/**
 * Inject credit CTA pads into the products list for the virtual scroller.
 * - Every 10 results
 * - If fewer than 10, as the second-to-last item
 * - If exactly 1 result, after the single item
 * Returns a new array with type='product' and type='credit' items.
 */
export function inject_credit_pads(products) {
  return products.flatMap((product, index) => {
    const should_inject =
      ((index + 1) % 10 === 0 && index !== 0) ||
      (products.length < 10 && index === products.length - 2) ||
      (products.length === 1 && index === 0)

    const product_item = { ...product, type: 'product' }

    if (should_inject) {
      return [{ type: 'credit', pidkey: `c-${index}` }, product_item]
    }

    return [product_item]
  })
}
